/* Copyright (c) 2019-2021 VMware, Inc. All rights reserved. VMware Confidential */
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

/**
 * Wrapper around Http service to be used by DPS UI application to access backend services
 */
@Injectable()
export class SrmHttp {

    constructor(public http: HttpClient) {
    }

    public sendRequest<T, U>(url: string,
                             requestData?: T,
                             queryParams?: HttpParams,
                             contentType?: string,
                             customHeaders?: HttpHeaders): Observable<U> {

        return this.sendRequestInternal<T, U>(url,
                                              requestData,
                                              queryParams,
                                              contentType,
                                              customHeaders);
    }

    protected sendRequestInternal<T, U>(url: string,
                                        requestData?: T,
                                        queryParams?: HttpParams,
                                        contentType?: string,
                                        customHeaders?: HttpHeaders): Observable<U> {
        let httpHeaders: HttpHeaders;
        if (customHeaders) {
            httpHeaders = customHeaders;
        } else {
            httpHeaders = new HttpHeaders();
        }

        if (!contentType) {
            contentType = "application/json";
        }

        httpHeaders = httpHeaders.append("content-type", contentType);

        const httpStream: Observable<HttpResponse<U>> =
            this.http.post<U>(
                url,
                requestData,
                {
                    headers: httpHeaders,
                    observe: "response",
                    params: queryParams,
                    responseType: "json"
                });

        // TODO: let result: PromiseObservable<U> = new PromiseObservable<U>();
        // ResponseUtil.transformServerResult<U>(httpStream)
        //             .take(1)
        //             .subscribe(result);
        //return result;
        return httpStream.pipe(map(response => response.body));
    }
}
